import React from "react";
// import CircularProgress from '@mui/material/CircularProgress';
// import Box from '@mui/material/Box';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1 style={{ textAlign: "center" }}>Something went wrong.</h1>
          {/* <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box> */}
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

// https://reactjs.org/docs/error-boundaries.html
